/**
 * ChatBubble — Floating action button (FAB) fixed to the bottom-right corner.
 *
 * Clicking toggles the chat panel open/closed. Shows an unread indicator
 * dot when there are new assistant messages the user hasn't seen.
 */

/**
 * @param {{
 *   onClick: () => void,
 *   hasUnread: boolean
 * }} props
 */
export default function ChatBubble({ onClick, hasUnread }) {
  return (
    <button
      onClick={onClick}
      className="
        fixed bottom-4 right-4 sm:bottom-6 sm:right-6
        w-14 h-14 rounded-full bg-blue-600 text-white
        shadow-lg hover:bg-blue-700 hover:shadow-xl
        transition-all duration-200
        flex items-center justify-center
        z-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
      "
      title="Open chat"
    >
      {/* Chat bubble SVG icon */}
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
        />
      </svg>

      {/* Unread indicator dot */}
      {hasUnread && (
        <span className="absolute top-0 right-0 w-3.5 h-3.5 bg-red-500 rounded-full border-2 border-white" />
      )}
    </button>
  );
}
